var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotLineMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.52 53.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea262a;}.cls-2{fill:none;stroke:var(--primary-color);stroke-miterlimit:10;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.76,
    cy: 26.76,
    r: 20.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 26.76,
    cy: 26.76,
    r: 26.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37,31.16a4.66,4.66,0,0,0-1-.63c-.35-.18-2.94-1.45-3.43-1.62s-.89-.32-1.31.31c-.33.47-1.27,1.57-1.58,1.92s-.41.33-.89.09a17.28,17.28,0,0,1-4-2.44A14.88,14.88,0,0,1,22,25.39c-.22-.37-.07-.54.2-.81s.89-1,1-1.13.33-.61.33-.61a1.06,1.06,0,0,0,0-1c-.09-.17-1.42-3.37-1.54-3.67-.38-.91-.79-.95-1.17-.93-.19,0-1.95,0-2.51.63l-.1.11a5.58,5.58,0,0,0-1.7,4.14,6.3,6.3,0,0,0,.27,1.73,11.06,11.06,0,0,0,1.81,3.5s1.3,1.81,1.95,2.55a17.6,17.6,0,0,0,6.66,5c3,1.16,4.23,1.42,4.95,1.42.31,0,1-.16,1.12-.17.9-.08,3.06-1.21,3.51-2.47A4.09,4.09,0,0,0,37,31.16Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotLineMobile);
export default __webpack_public_path__ + "static/media/hotLineMobile.cc9cc181bcb545b1623efcd7eefc1a4a.svg";
export { ForwardRef as ReactComponent };